<template>
  <div>
    <v-col>
      <v-autocomplete
        v-model="value"
        :label="label"
        :prepend-icon="icon"
        :items="theSubProdutos"
        :multiple="multiple"
        item-text="descricao"
        return-object
        @click="selectAllSubProducts"
        @input="$emit('input', $event)"
      ></v-autocomplete>
    </v-col>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
export default {
  name: 'RelatorioCargaDescargaListFiltroModalItemInputSubProduto',
  props: {
    name: {
      type: String,
      required: true,
    },
    value: {
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
    },
    rules: {
      type: [Object, String],
    },
    produto: {
      required: true,
    },
    multiple: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      selectSubProdutos: [],
    }
  },
  computed: {
    ...mapState('subProdutos', ['subProdutos']),
    ...mapState('auth', ['user', 'empresaAtual', 'perfilAtual']),
    theSubProdutos() {
      if (this.value) {
        if (this.multiple) {
          return [...this.value].concat(this.selectSubProdutos.filter(c => !this.value.some(v => v.id === c.id)))
        }
        return [this.value].concat(this.selectSubProdutos.filter(c => this.value.id != c.id))
      }
      return this.selectSubProdutos
    }
  },
  methods: {
    ...mapActions('template', [
      'successMessage',
      'errorMessage',
      'setDialogMessage',
    ]),
    ...mapMutations('subProdutos', ['setSubProduto']),
    async selectAllSubProducts() {
      if (this.produto.id != null) {
        this.setSubProduto(this.produto.subprodutos)
        this.selectSubProdutos = [...this.subProdutos]
        return 
      } 
      if (Array.isArray(this.produto)) {
        let allSubProducts = []
        this.produto.forEach((prod) => {
          allSubProducts = allSubProducts.concat(prod.subprodutos)
        })
        this.setSubProduto(allSubProducts)
        this.selectSubProdutos = [...this.subProdutos]
        return
      }
      this.selectProduto = [{ descricao: 'Nenhum', id: null }]
    },
  },
  async created() {},
}
</script>
